import { putObject } from '../utils/uploadToStorage';
import { fetchModelBlob, type PolyModel } from './polyPizzaApi';

/**
 * Copy a Poly Pizza model into our storage and return its URL — library items
 * must not depend on poly.pizza staying up. Falls back to the source URL if
 * the copy fails. Used by the desktop library and the VR library.
 */
export async function importLibraryModel(model: PolyModel): Promise<string> {
  const blob = await fetchModelBlob(model.downloadUrl);
  try {
    const key = `objects/library-${model.id}-${Date.now()}.glb`;
    return await putObject(key, blob, 'model/gltf-binary');
  } catch (persistErr) {
    console.warn('[ObjectLibrary] S3 persist failed, using source URL:', persistErr);
    return model.downloadUrl;
  }
}
